var map = {
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"common",
		"auth-auth-module"
	],
	"./checkout/checkout.module": [
		"./src/app/checkout/checkout.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~checkout-checkout-module~dashboard-navbar-patients-patients-module~dashboard-navbar-patients~3a711948",
		"default~checkout-checkout-module~dashboard-navbar-super-admin-super-admin-module~dashboard-navbar-us~63adf7eb",
		"common",
		"checkout-checkout-module"
	],
	"./dashboard/navbar/allergies/allergies.module": [
		"./src/app/main/dashboard/navbar/allergies/allergies.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-allergies-allergies-module"
	],
	"./dashboard/navbar/change-password/change-password.module": [
		"./src/app/main/dashboard/navbar/change-password/change-password.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"common",
		"dashboard-navbar-change-password-change-password-module"
	],
	"./dashboard/navbar/daily-reports/daily-reports.module": [
		"./src/app/main/dashboard/navbar/daily-reports/daily-reports.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"common",
		"dashboard-navbar-daily-reports-daily-reports-module"
	],
	"./dashboard/navbar/diagnoses/diagnoses.module": [
		"./src/app/main/dashboard/navbar/diagnoses/diagnoses.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-diagnoses-diagnoses-module"
	],
	"./dashboard/navbar/dispensary-sales/dispensary-sales.module": [
		"./src/app/main/dashboard/navbar/dispensary-sales/dispensary-sales.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-dispensary-sales-dispensary-sales-module"
	],
	"./dashboard/navbar/dispensers/dispensers.module": [
		"./src/app/main/dashboard/navbar/dispensers/dispensers.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-dispensers-dispensers-module"
	],
	"./dashboard/navbar/doctors/doctors.module": [
		"./src/app/main/dashboard/navbar/doctors/doctors.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-doctors-doctors-module"
	],
	"./dashboard/navbar/drugs/drugs.module": [
		"./src/app/main/dashboard/navbar/drugs/drugs.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"default~dashboard-navbar-drugs-drugs-module~dashboard-navbar-patients-tabs-patients-tabs-module",
		"common",
		"dashboard-navbar-drugs-drugs-module"
	],
	"./dashboard/navbar/expenses-types/expenses-types.module": [
		"./src/app/main/dashboard/navbar/expenses-types/expenses-types.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-expenses-types-expenses-types-module"
	],
	"./dashboard/navbar/expenses/expenses.module": [
		"./src/app/main/dashboard/navbar/expenses/expenses.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-expenses-expenses-module"
	],
	"./dashboard/navbar/forms/forms.module": [
		"./src/app/main/dashboard/navbar/forms/forms.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-forms-forms-module"
	],
	"./dashboard/navbar/grns/grns.module": [
		"./src/app/main/dashboard/navbar/grns/grns.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"common",
		"dashboard-navbar-grns-grns-module"
	],
	"./dashboard/navbar/investigations/investigations.module": [
		"./src/app/main/dashboard/navbar/investigations/investigations.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-investigations-investigations-module"
	],
	"./dashboard/navbar/lab-report-sales/lab-report-sales.module": [
		"./src/app/main/dashboard/navbar/lab-report-sales/lab-report-sales.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-lab-report-sales-lab-report-sales-module"
	],
	"./dashboard/navbar/lab-reports/lab-reports.module": [
		"./src/app/main/dashboard/navbar/lab-reports/lab-reports.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-lab-reports-lab-reports-module"
	],
	"./dashboard/navbar/labs/labs.module": [
		"./src/app/main/dashboard/navbar/labs/labs.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-labs-labs-module"
	],
	"./dashboard/navbar/letters/letters.module": [
		"./src/app/main/dashboard/navbar/letters/letters.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"default~dashboard-navbar-letters-letters-module~dashboard-navbar-patients-tabs-patients-tabs-module",
		"common",
		"dashboard-navbar-letters-letters-module"
	],
	"./dashboard/navbar/medical-histories/medical-histories.module": [
		"./src/app/main/dashboard/navbar/medical-histories/medical-histories.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-medical-histories-medical-histories-module"
	],
	"./dashboard/navbar/medical-records/medical-records.module": [
		"./src/app/main/dashboard/navbar/medical-records/medical-records.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-medical-records-medical-records-module"
	],
	"./dashboard/navbar/morbidities/morbidities.module": [
		"./src/app/main/dashboard/navbar/morbidities/morbidities.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-morbidities-morbidities-module"
	],
	"./dashboard/navbar/outcomes/outcomes.module": [
		"./src/app/main/dashboard/navbar/outcomes/outcomes.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-outcomes-outcomes-module"
	],
	"./dashboard/navbar/patients-tabs/patients-tabs.module": [
		"./src/app/main/dashboard/navbar/patients-tabs/patients-tabs.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"default~checkout-checkout-module~dashboard-navbar-patients-patients-module~dashboard-navbar-patients~3a711948",
		"default~dashboard-navbar-patients-patients-module~dashboard-navbar-patients-tabs-patients-tabs-modul~973256ae",
		"default~dashboard-navbar-letters-letters-module~dashboard-navbar-patients-tabs-patients-tabs-module",
		"default~dashboard-navbar-patients-tabs-patients-tabs-module~main-main-module",
		"default~dashboard-navbar-drugs-drugs-module~dashboard-navbar-patients-tabs-patients-tabs-module",
		"common",
		"dashboard-navbar-patients-tabs-patients-tabs-module"
	],
	"./dashboard/navbar/patients/patients.module": [
		"./src/app/main/dashboard/navbar/patients/patients.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"default~checkout-checkout-module~dashboard-navbar-patients-patients-module~dashboard-navbar-patients~3a711948",
		"default~dashboard-navbar-patients-patients-module~dashboard-navbar-patients-tabs-patients-tabs-modul~973256ae",
		"common",
		"dashboard-navbar-patients-patients-module"
	],
	"./dashboard/navbar/payment/payment.module": [
		"./src/app/main/dashboard/navbar/payment/payment.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"common",
		"dashboard-navbar-payment-payment-module"
	],
	"./dashboard/navbar/prescriptions/prescriptions.module": [
		"./src/app/main/dashboard/navbar/prescriptions/prescriptions.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"default~dashboard-navbar-patients-patients-module~dashboard-navbar-patients-tabs-patients-tabs-modul~973256ae",
		"common",
		"dashboard-navbar-prescriptions-prescriptions-module"
	],
	"./dashboard/navbar/procedures/procedures.module": [
		"./src/app/main/dashboard/navbar/procedures/procedures.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-procedures-procedures-module"
	],
	"./dashboard/navbar/setting/setting.module": [
		"./src/app/main/dashboard/navbar/setting/setting.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"common",
		"dashboard-navbar-setting-setting-module"
	],
	"./dashboard/navbar/super-admin-view/super-admin-view.module": [
		"./src/app/main/dashboard/navbar/super-admin-view/super-admin-view.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-super-admin-view-super-admin-view-module"
	],
	"./dashboard/navbar/super-admin/super-admin.module": [
		"./src/app/main/dashboard/navbar/super-admin/super-admin.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~checkout-checkout-module~dashboard-navbar-super-admin-super-admin-module~dashboard-navbar-us~63adf7eb",
		"common",
		"dashboard-navbar-super-admin-super-admin-module"
	],
	"./dashboard/navbar/surgical-histories/surgical-histories.module": [
		"./src/app/main/dashboard/navbar/surgical-histories/surgical-histories.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"common",
		"dashboard-navbar-surgical-histories-surgical-histories-module"
	],
	"./dashboard/navbar/user-profile/user-profile.module": [
		"./src/app/main/dashboard/navbar/user-profile/user-profile.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~checkout-checkout-module~dashboard-navbar-super-admin-super-admin-module~dashboard-navbar-us~63adf7eb",
		"common",
		"dashboard-navbar-user-profile-user-profile-module"
	],
	"./dispensary-purchase/dispensary-purchase.module": [
		"./src/app/checkout/dispensary-purchase/dispensary-purchase.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~checkout-checkout-module~dashboard-navbar-patients-patients-module~dashboard-navbar-patients~3a711948",
		"default~checkout-checkout-module~dashboard-navbar-super-admin-super-admin-module~dashboard-navbar-us~63adf7eb",
		"common",
		"dispensary-purchase-dispensary-purchase-module"
	],
	"./lab-report-sales/lab-report-sales.module": [
		"./src/app/checkout/lab-report-sales/lab-report-sales.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~checkout-checkout-module~dashboard-navbar-super-admin-super-admin-module~dashboard-navbar-us~63adf7eb",
		"common",
		"lab-report-sales-lab-report-sales-module"
	],
	"./lab-report/lab-report.module": [
		"./src/app/checkout/lab-report/lab-report.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~checkout-checkout-module~dashboard-navbar-patients-patients-module~dashboard-navbar-patients~3a711948",
		"default~checkout-checkout-module~dashboard-navbar-super-admin-super-admin-module~dashboard-navbar-us~63adf7eb",
		"common",
		"lab-report-lab-report-module"
	],
	"./main/main.module": [
		"./src/app/main/main.module.ts",
		"default~auth-auth-module~checkout-checkout-module~dashboard-navbar-allergies-allergies-module~dashbo~6bda3a2a",
		"default~dashboard-navbar-allergies-allergies-module~dashboard-navbar-diagnoses-diagnoses-module~dash~a83e78ef",
		"default~checkout-checkout-module~dashboard-navbar-patients-patients-module~dashboard-navbar-patients~3a711948",
		"default~dashboard-navbar-patients-patients-module~dashboard-navbar-patients-tabs-patients-tabs-modul~973256ae",
		"default~dashboard-navbar-patients-tabs-patients-tabs-module~main-main-module",
		"common",
		"main-main-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;